import { render, staticRenderFns } from "./player.vue?vue&type=template&id=35841072&scoped=true&"
import script from "./player.vue?vue&type=script&lang=ts&"
export * from "./player.vue?vue&type=script&lang=ts&"
import style0 from "./player.vue?vue&type=style&index=0&id=35841072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35841072",
  null
  
)

export default component.exports